import * as React from 'react';
import PropTypes from 'prop-types';

// Text ⟷ Vector search-scope toggle (COMMAND_PALETTE.md). A segmented control;
// `role="switch"` on each option. Mouse-down (not click) so it fires before the
// input's blur and keeps the search open. Shared by the command palette (modal)
// and the top-bar inline search dropdown.
export default function ScopeToggle({ mode, onChange, testIdPrefix = 'palette-scope' }) {
  const opt = (value, label) => (
    <button
      type="button"
      role="switch"
      aria-checked={mode === value}
      aria-label={`${label} search`}
      data-testid={`${testIdPrefix}-${value}`}
      className={`seg-btn${mode === value ? ' active' : ''}`}
      onMouseDown={(e) => { e.preventDefault(); onChange(value); }}
      style={{
        border: 'none', cursor: 'pointer', font: 'inherit', fontSize: 12, padding: '3px 10px',
        borderRadius: 6, background: mode === value ? 'var(--accent, #0A6BEB)' : 'transparent',
        color: mode === value ? '#fff' : 'inherit',
      }}
    >
      {label}
    </button>
  );
  return (
    <div
      className="seg"
      title="Text = keyword search · Vector = semantic search"
      style={{ display: 'inline-flex', gap: 2, padding: 2, borderRadius: 8, border: '1px solid var(--border)' }}
    >
      {opt('text', 'Text')}
      {opt('vector', 'Vector')}
    </div>
  );
}

ScopeToggle.propTypes = {
  mode: PropTypes.oneOf(['text', 'vector']).isRequired,
  onChange: PropTypes.func.isRequired,
  testIdPrefix: PropTypes.string,
};
